const defaultState = {
  contentSources: {},
};

const getters = {
  get: (state) => state.contentSources,
  list: (state) => Object.keys(state.contentSources).map(id => state.contentSources[id]),
};

const mutations = {
  set: function(state, contentSources) {
    contentSources.forEach(contentSource => {
      state.contentSources[contentSource.id] = contentSource;
    });
  },
};

const actions = { };

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
